const regexes = {
	Email: /^\S+@\S+\.\S+$/,
	OnlyNumbers: /^\d+$/,
} as const;

export default regexes;
